module.exports = __webpack_public_path__ + "ec71ca41b2869db8472f4810478fa4f4.svg";